const currency_code = window.drupalSettings &&
window.drupalSettings.common &&
window.drupalSettings.common.currency_code.length > 0 ?
  window.drupalSettings.common.currency_code:
  '';

export default currency_code;

